// extracted by mini-css-extract-plugin
export var cardContainer = "_q6-0";
export var cardHeader = "_q6-2";
export var collapsedState = "_q6-3";
export var dragHandle = "_q6-5";
export var dragHandleIcon = "_q6-6";
export var dragging = "_q6-1";
export var titleArea = "_q6-4";